import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-mailsubscription-content',
  templateUrl: './mailsubscription-content.component.html',
  styleUrls: ['./mailsubscription-content.component.css']
})
export class MailsubscriptionContentComponent implements OnInit {

  constructor(private accountservcie: AccountService,private toastr: ToastrService) { }

  ngOnInit() {
  }
  
  model:{
    emailaddress:string,
    Reason:string
  }={emailaddress:"",Reason:"" };
subscriptionState:string="Unsubscribe";


OnSubmit()
{
const result=this.accountservcie.Unsubsciribe(this.model).subscribe((data)=>{
  if(data.Result===true){
 this.subscriptionState="Unsubscribed"; 
 this.model={emailaddress:"",Reason:""};
 this.toastr.success("Unsubscribed Successfully");
   
  }
  else{
this.toastr.error(data.message);
  }
});
// if(this.model.emailaddress)

}
}
